module.exports = __webpack_public_path__ + "img/space-introduce-2-en.1e4b935c.svg";